module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Medium.woff?9053572c46aeb4b16caafd643a543b8d";